import { Component, inject, OnInit } from '@angular/core';
import { DpFormModule, DpSectionForm } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { GeneralConfig, GeneralSettingsConfig } from './general-config.model';
import { GeneralFormService } from './services/general-form.service';
import { GeneralHttpService } from './services/general-http.service';

@Component({
  selector: 'app-configuration-general',
  templateUrl: './general.component.html',
  standalone: true,
  imports: [DpFormModule]
})
export class GeneralComponent implements OnInit {

  private readonly header = 'general.form';

  faCog = faCog;
  sectionForm: DpSectionForm;

  private readonly generalHttpService = inject(GeneralHttpService);
  private readonly generalService = inject(GeneralFormService);
  private readonly cloudService = inject(CloudService);

  constructor() {
    this.sectionForm = this.generalService.getSectionForm();
  }

  ngOnInit(): void {
    this.generalHttpService.getConfig().subscribe(config => {
      this.sectionForm.setValue(config);
    });

  }

  submitForm(value: unknown) {
    const config = value as GeneralConfig;
    let generalSettingsConfig!: GeneralSettingsConfig;

    if (!this.cloudService.isModeCloud()) {
      const { ...configWithoutSeconds } = config.general;
      generalSettingsConfig = new GeneralSettingsConfig(
        configWithoutSeconds.workingDirectory,
        configWithoutSeconds.batchSizeDeletingJobs,
        configWithoutSeconds.refreshLastHour
      );
    }

    const modifiedConfig = new GeneralConfig(
      generalSettingsConfig,
      config.log,
      config.email,
      config.sms
    );

    this.generalHttpService.updateConfig(modifiedConfig).subscribe(() => {
      this.sectionForm.setValue(config);
    });
  }
}
